import axios from "axios";
import { UserModule } from "@/store/modules/user";
import { getSignJson } from "@/utils/sign";
import { decodeStr } from '@/utils/common';
const service = axios.create({
    timeout: 10000,
    headers: {
        post: {
            "Content-Type": "application/x-www-form-urlencoded;",
            "Cache-Control": "no-cache",
        },
    },
});
service.getExportFile = function (url) {
    let map = {};
    let datas = url.split("?")[1];
    if (datas) {
        datas.split("&").forEach(i => {
            i.replace(/(.*)=(.*)/, (all, key, value) => {
                map[key] = decodeStr(value); // 解码回原来的字符，因为后端校验签名时用解码后的
                return all;
            });
        });
    }
    const { sign, timestamp } = getSignJson(map);
    return service.get(url, {
        responseType: 'blob',
        withCredentials: true,
        headers: {
            "Cache-Control": "no-cache",
            sign: sign,
            timestamp: timestamp
        }
    });
};
service.postExportFile = function (url, data) {
    const { sign, timestamp } = getSignJson(data);
    return service.post(url, data, {
        responseType: 'blob',
        withCredentials: true,
        headers: {
            "Cache-Control": "no-cache",
            sign: sign,
            timestamp: timestamp
        }
    });
};
// 请求拦截器
service.interceptors.request.use((config) => {
    // 为每个请求添加token信息
    if (UserModule.token) {
        config.headers.token = UserModule.token;
    }
    if (UserModule.email) {
        config.headers.email = UserModule.email;
    }
    if (UserModule.ssoId) {
        config.headers.ssoUserId = UserModule.ssoId;
    }
    if (UserModule.email) {
        config.headers.email = UserModule.email;
    }
    return config;
}, (error) => {
    return Promise.reject(error);
});
export default service;
